import { render } from "./Productivity.vue?vue&type=template&id=10f6db2c"
import script from "./Productivity.vue?vue&type=script&lang=js"
export * from "./Productivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__